import {mapResourceMetadata} from './mapResourceMetadata';
import {mapUpdateResourceBasePayload} from './mapUpdateResourceBasePayload';
import {IEditFileMetadataFormBaseValues} from '../components/FilesEditResourceForm/config';
import {emptyResourceMetadataLookupNames, IResourceMetadataLookupNames} from 'admin/resources/utils';

export const mapUpdateResourceFilePayload = (
  fileId: string,
  formValues: IEditFileMetadataFormBaseValues,
  lookupNames: IResourceMetadataLookupNames = emptyResourceMetadataLookupNames()
) => {
  const metadata = mapResourceMetadata(formValues, lookupNames);
  const data = mapUpdateResourceBasePayload({data: new FormData(), fileId, metadata}, formValues);

  data.append('fileTypeId', formValues.fileType.toString());

  return data;
};
